import { combineReducers } from "@reduxjs/toolkit";
import productDetailReducer from "./productDetailSlice";
import productListReducer from "./productListSlice";
import cartReducer from "./cartSlice";
import wishlistReducer from "./wishlistSlice";
import fullCartReducer from "./fullCartSlice";


/**
 * Combines all individual slice reducers into a single root reducer for the Redux store.
 *
 * @remarks
 * This root reducer manages the overall state shape of the application by delegating
 * state updates to the respective slice reducers: `productDetail`, `productList`, `cart`, and `wishlist`.
 *
 * @returns The combined reducer function to be used in Redux store configuration.
 */
const rootReducer = combineReducers({
  productDetail: productDetailReducer,
  productList: productListReducer,
  cart: cartReducer,
  wishlist: wishlistReducer,
  fullCart: fullCartReducer,
});

export default rootReducer;
